$(document).ready(function() {
  // Play Sound
  function getCurrentVideo() {
    return $('.video-section__media video').get(0);
  }

  function toggleSound() {
    var video = getCurrentVideo();
    var $toggleButton = $("#toggleSoundButton");
    video.muted = !video.muted;
    
    if (!video.muted) {
      $toggleButton.removeClass('muted');
    } else {
      $toggleButton.addClass('muted');
    }

    video.play().catch(error => console.error("Error trying to play the video:", error));
  }
  
  $("#toggleSoundButton").on("click", toggleSound);

  function adjustVideoDisplay() {
    var isDesktop = window.matchMedia("(orientation: landscape) and (min-width: 750px)").matches;
    if(isDesktop !== wasDesktop) {
      $('video').each(function() {
        this.muted = true;
        this.play().catch(error => console.error("Error trying to play the video:", error));
      });

      var $toggleButton = $("#toggleSoundButton");
      $toggleButton.addClass('muted');
      
      wasDesktop = isDesktop;
    }
  }
  
  //adjustVideoDisplay();
  
  //$(window).on('resize', adjustVideoDisplay);
  //$(window).on('orientationchange', adjustVideoDisplay);
})